<template>
  <SectionTemplate
    :title="title"
    desc="4种创作入口，零基础也能轻松上手。"
    class="create-like-a-pro-section"
  >
    <VideoCarousel :infos="infos" :muted="true" />
  </SectionTemplate>
</template>

<script lang="ts" setup>
import { useBreakpoint } from '@rendora/design/index';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import VideoCarousel from '../../components/video-carousel.vue';

const headers = useRequestHeaders();
const { isMobile } = useBreakpoint(headers?.['user-agent']);

const title = computed(() =>
  isMobile.value
    ? '无需拍摄剪辑 人人都能轻松生\n成专业级视频'
    : '无需拍摄剪辑\n人人都能轻松生成专业级视频',
);

const infos: {
  title: string;
  url: string;
  poster: string;
  videoDesc: string;
}[] = [
  {
    title: '从零开始创作',
    url: getFeUrl('/youyan-platform/main/create-like-a-pro/1.webm'),
    poster: getFeUrl('/youyan-platform/main/create-like-a-pro/1.jpg'),
    videoDesc: '使用有言可以从零开始创作AI数字人视频',
  },
  {
    title: '从模版开始创作',
    url: getFeUrl('/youyan-platform/main/create-like-a-pro/2.webm'),
    poster: getFeUrl('/youyan-platform/main/create-like-a-pro/2.jpg'),
    videoDesc: '有言提供数千个AI数字人模板帮助用户创作视频',
  },
  {
    title: '从AI脚本创作',
    url: getFeUrl('/youyan-platform/main/create-like-a-pro/3.webm'),
    poster: getFeUrl('/youyan-platform/main/create-like-a-pro/3.jpg'),
    videoDesc: '可以使用有言的AI视频脚本助手帮助用户创作视频',
  },
  {
    title: '从PPT开始创作',
    url: getFeUrl('/youyan-platform/main/create-like-a-pro/4.webm'),
    poster: getFeUrl('/youyan-platform/main/create-like-a-pro/4.jpg'),
    videoDesc: '用户可以在有言上传PPT或使用官方PPT创作3D数字人视频',
  },
];
</script>
<style lang="scss" scoped src="./pc.scss"></style>
<style lang="scss" scoped src="./mobile.scss"></style>
